import { Card, HStack, Stack, Text } from "@chakra-ui/react";
import { KeyboardHint } from "../../../../shared/views/KeyboardHint/KeyboardHint";
import { observer } from "mobx-react";
import { useStores } from "../../../../shared/stores/RootStore";
import { MapComponent, MapMode } from "../../../../project/stores/MapStore";
import { ToggleVisibilityButton } from "../../ToggleVisibilityButton";
import { ReactNode } from "react";

const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;

const ctrlKey = isMac ? "⌘" : "Ctrl";
const leftKey = <>&#8592;</>;
const rightKey = <>&#8594;</>;
const shiftKey = "⇧";

const ShortcutListBase = () => {
  const { osaNodeStore, mapStore } = useStores();

  const shortcuts: ReactNode[] = [];

  if (
    mapStore.mode === MapMode.HlaCoding ||
    mapStore.mode === MapMode.ProjectPage
  ) {
    shortcuts.push(
      <HStack key="multi-select">
        <KeyboardHint
          keys={[shiftKey, <Text fontSize={"xs"}>click</Text>]}
          label="or"
        />
        <KeyboardHint
          keys={[shiftKey, <Text fontSize={"xs"}>drag</Text>]}
          label={`to select multiple HLA`}
        />
      </HStack>,
    );
  }

  if (
    mapStore.mode === MapMode.CraCoding ||
    mapStore.mode === MapMode.ManageNodes
  ) {
    shortcuts.push(
      <HStack key="multi-select">
        <KeyboardHint
          keys={[shiftKey, <Text fontSize={"xs"}>click</Text>]}
          label="or"
        />
        <KeyboardHint
          keys={[shiftKey, <Text fontSize={"xs"}>drag</Text>]}
          label={`to select multiple CRA`}
        />
      </HStack>,
    );
  }

  if (osaNodeStore.selectedId) {
    shortcuts.push(
      <KeyboardHint
        key="previous node"
        keys={[leftKey]}
        label={`to go to the previous node`}
      />,
      <KeyboardHint
        key="next node"
        keys={[rightKey]}
        label={`to go to the next node`}
      />,
      <KeyboardHint
        key="first node"
        keys={[ctrlKey, leftKey]}
        label={`to go to the first node`}
      />,
      <KeyboardHint
        key="last node"
        keys={[ctrlKey, rightKey]}
        label={`to go to the last node`}
      />,
    );
  }

  if (!shortcuts.length) return null;

  return (
    <Card.Root bgColor={"rgba(255,255,255,0.7)"}>
      <Stack direction={"row"} minH={"50px"}>
        {mapStore.componentVisibility.shortcuts && (
          <Stack fontSize="sm" p={2}>
            <Text textStyle={"label"}>Tips</Text>
            {shortcuts}
          </Stack>
        )}

        <ToggleVisibilityButton
          component={MapComponent.Shortcuts}
          arrowAngleWhenOpen={180}
        />
      </Stack>
    </Card.Root>
  );
};

export const ShortcutList = observer(ShortcutListBase);
